import startCase from 'lodash/startCase'
export default function format (entity, item) {
    // console.error(type)
    switch (entity) {
    
        case 'user':
        case 'sites':
            return item?.map( s => s?.code)?.join(', ')

        // special case to transform field name into label (mainly used for audit trail foreigns)
        case 'field_name':
            if (item === 'n_pieces') {
                return 'Quantity'
            }
            return startCase(item.replace('_', ' ').replace(/ id$/, ''))
        case 'field_value':
            return item
        default:
            return item?.name ?? item
    }
}